import { createSlice } from '@reduxjs/toolkit'

const BrowseCoursesStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    courses: [],
    status: BrowseCoursesStatus.LOADING,
    errorMessage: null,
    paging: {
        pageNo: 1,
        pageSize: 10,
        pageCount: 1,
        totalRecordCount: 1,
    },
    categories: [
        {
            text: 'All Courses',
            id: null,
        },
    ],
    categoriesStatus: BrowseCoursesStatus.LOADING,
    categoriesError: null,
}

const browseCoursesSlice = createSlice({
    name: 'browseCourses',
    initialState,
    reducers: {
        getCoursesRequest: state => {
            state.status = BrowseCoursesStatus.LOADING
        },
        getCoursesRequestSuccess: (state, action) => {
            state.status = BrowseCoursesStatus.SUCCESS
            const { courses, paging } = action.payload
            state.courses = courses.map(course => {
                course.downloads = course.downloadableMaterial
                course.lectures = course.numberOfLectures
                course.category = course.catName
                return course
            })
            state.paging = paging
        },
        getCoursesRequestError: (state, action) => {
            state.status = BrowseCoursesStatus.FAILURE
            state.errorMessage = action.payload
        },
    },
})

const {
    getCoursesRequest,
    getCoursesRequestSuccess,
    getCoursesRequestError,
} = browseCoursesSlice.actions

export const browseCoursesActions = {
    getCoursesRequest,
    getCoursesRequestSuccess,
    getCoursesRequestError,
}

export const browseCoursesSelectors = {
    isFetching: state =>
        state.browseCourses.status === BrowseCoursesStatus.LOADING,
    errorMessage: state => state.browseCourses.errorMessage,
    hasError: state =>
        state.browseCourses.status === BrowseCoursesStatus.FAILURE,
    paging: state => state.browseCourses.paging,
    courses: state => state.browseCourses.courses,
}

//For intellisense
const browseCoursesReducer = browseCoursesSlice.reducer

export default browseCoursesReducer
